import styled from 'styled-components/macro';
import { colorAccentError700, colorBlackTransparent50 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { Z_INDEX } from '@yme/tokens/zindex';
const THUMB_HEIGHT = 16;
const TRACK_HEIGHT = 4;
export const ThumbStyled = styled.div `
  width: ${THUMB_HEIGHT}px;
  height: ${THUMB_HEIGHT}px;
  background-color: ${colorAccentError700};
  border-radius: ${CORNER_RADIUS.circle};
  z-index: ${Z_INDEX.level2};
  outline: none;

  &::after {
    content: '';
    position: absolute;
    top: ${THUMB_HEIGHT / 2}px;
    left: ${THUMB_HEIGHT / 2}px;
    transform: translate(-50%, -50%);
    width: ${THUMB_HEIGHT * 2}px;
    height: ${THUMB_HEIGHT * 2}px;
    background-color: ${colorBlackTransparent50};
    border-radius: ${CORNER_RADIUS.circle};
    display: none;
  }

  &:hover {
    &::after {
      display: block;
    }
  }
`;
export const TrackStyled = styled.div `
  bottom: 0;
  top: ${(THUMB_HEIGHT - TRACK_HEIGHT) / 2}px;
  height: ${TRACK_HEIGHT}px;
  border-radius: ${CORNER_RADIUS.xs};

  ${({ index }) => `
    background: ${index === 1 ? colorAccentError700 : colorBlackTransparent50}
  `}
`;
